import axios from 'axios'
import qs from 'qs'
import errorImg from '../images/no-source.png'
import { updateSuccess } from '../utils/connectApp'


export function setLiveroomSettingLectureInit() {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_INIT',
    }
}

export function setIsScrollStop(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SCROLL_STOP',
        payload,
    }
}

export function setIsScrollKill(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SCROLL_KILL',
        payload,
    }
}

export function setlecturesOffset(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_OFFSET',
        payload,
    }
}

export function setlecturesIsMore(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_IS_MORE',
        payload,
    }
}

export function setlecturesCount(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_COUNT',
        payload,
    }
}

export function setError(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_ERROR',
        payload,
    }
}

export function setLectures (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_LECTURES',
        payload,
    }
}

export function setChannels (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CHANNELS',
        payload,
    }
}

export function setIsPending (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_PENDING',
        payload,
    }
}

export function setIsSuccess (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SUCCESS',
        payload,
    }
}

export function setIsAlert (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_ALERT',
        payload,
    }
}

export function setInfo (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_INFO',
        payload,
    }
}

export function setAlertMsg (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_ALERT_MSG',
        payload,
    }
}

export function setIsLecMenuShow (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_LEC_MENU_SHOW',
        payload,
    }
}

export function setIsChaMenuShow (payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_CHA_MENU_SHOW',
        payload,
    }
}

export function setQrcodeInit(payload) {
    return {
        type: 'CUSTOMER_QRCODE_INIT',
        payload,
    }
}

export function setQrcodeShow() {
    return {
        type: 'CUSTOMER_QRCODE_SHOW'
    }
}

export function setQrcodeHide() {
    return {
        type: 'CUSTOMER_QRCODE_HIDE'
    }
}

export function setIsNoDel(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_NO_DEL',
        payload,
    }
}

export function setNoDelReason(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_NO_DEL_REASON',
        payload,
    }
}

export function setCurrentLecture(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_LECTURE',
        payload,
    }
}

export function setCurrentChannel(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_CHANNEL',
        payload,
    }
}

export function setIsShowDelLecture(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_DEL_LEC',
        payload,
    }
}

export function setIsShowMoveChannels(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_MOVE_CHANNELS',
        payload,
    }
}

export function setIsShowDelChannel(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_DEL_CHA',
        payload,
    }
}

export function setLectureKeyword(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_LECTURE_KEYWORD',
        payload,
    }
}

export function setChannelKeyword(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CHANNEL_KEYWORD',
        payload,
    }
}

export function setCurrentLectureInfo(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_LECTURE_INFO',
        payload,
    }
}

export function setMoveToChannelId(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_MOVE_TO_CHANNEL_ID',
        payload,
    }
}

export function setIsShowAtList(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_AT_LIST',
        payload,
    }
}

export function setIsSearchEmpty(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_SEARCH_EMPTY',
        payload,
    }
}

export function setIsLecturesEmpty(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_LECTURES_EMPTY',
        payload,
    }
}

export function setIsChannelsEmpty(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_IS_CHANNELS_EMPTY',
        payload,
    }
}

export function setCurrentChannelIndex(payload) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_CHANNEL_INDEX',
        payload,
    }
}

export function exchangeChannel(aindex, bindex) {
    return {
        type: 'LIVEROOM_SETTING_LECTURE_EXCHANGE_CHANNEL',
        channelA: aindex,
        channelB: bindex,
    }
}

export function fetchChannels (id, opts = {}) {
    const keyword = opts.keyword || ''
    // const limit = opts.limit || 50
    const offset = opts.offset || 0
    const isSearch = opts.isSearch
    return (dispatch, getState) => {
        axios.get(`/api/liveroom/${id}/dashboard`)
            .then(res => {
                const limit = res.data.data.stats_info.channel_count + 10
                return axios.get(`/api/liveroom/${id}/channel_list?keyword=${keyword}&limit=${limit}&offset=${offset}`)
            })
            .then(res => {
                dispatch(setChannels(res.data.data.channels))
                // dispatch(setChannels([]))
                dispatch(setIsPending(false))
                if (isSearch) {
                    dispatch(setIsSearchEmpty(res.data.data.channels.length === 0))
                } else {
                    dispatch(setIsChannelsEmpty(getState().liveroomSettingLecture.channels.length === 0))
                }
            })
            .catch((error) => httpCatch(error, dispatch))
    }
}

export function fetchLectures (id, opts = {}) {
    const keyword = opts.keyword || ''
    const limit = opts.limit || 20
    const offset = opts.offset || 0
    const preLectures = opts.preLectures || []
    const isSearch = opts.isSearch
    return (dispatch, getState) => {
        dispatch(setIsScrollStop(true))
        if (!isSearch) {
            axios.get(`/api/liveroom/${id}/dashboard`)
                .then(res => {
                    dispatch(setlecturesCount(res.data.data.stats_info.lecture_count))
                })
        }
        axios.get(`/api/liveroom/${id}/lecture_list?keyword=${keyword}&limit=${limit}&offset=${offset}`)
            .then(res => {
                dispatch(setLectures(preLectures.concat(res.data.data.lectures)))
                // dispatch(setLectures(preLectures.concat([])))
                dispatch(setIsPending(false))
                dispatch(setIsScrollStop(false))
                dispatch(setlecturesOffset(res.data.data.next_offset))
                dispatch(setIsScrollKill(!res.data.data.has_more))
                if (isSearch) {
                    dispatch(setIsSearchEmpty(res.data.data.lectures.length === 0))
                    dispatch(setlecturesCount(res.data.data.lectures.length))
                } else {
                    dispatch(setIsLecturesEmpty(getState().liveroomSettingLecture.lectures.length === 0))
                }
            })
            .catch((error) => httpCatch(error, dispatch))
    }
}

export function fetchLecture (id) {
    return dispatch => {
        axios.get(`/api/lecture/${id}/edit_info`)
            .then(res => {
                dispatch(setMoveToChannelId(res.data.data.lecture && res.data.data.lecture.channel_id || ''))
                dispatch(setIsShowAtList(res.data.data.lecture && res.data.data.lecture.show_in_liveroom_list || false))
            })
    }
}

export function httpCatch(error, dispatch) {
    if (error.response && error.response.status === 404) {
        dispatch(setError({ isError: true, status: 404 }))
        dispatch({
            type: 'ERROR_SHOW',
            payload: {
                tips: '无法找到该网页',
                img: errorImg,
                href: '/?st=liveroom_setting_main_404',
                btn: '去首页看看'
            }
        })
        return
    }
    if (error.response && error.response.status === 403) {
        dispatch(setError({ isError: true, status: 403 }))
        dispatch({
            type: 'ERROR_SHOW',
            payload: {
                tips: '你没有访问此页面的权限',
                img: errorImg,
                href: '/?st=liveroom_setting_main_403',
                btn: '去首页看看'
            }
        })
    }
}

export function postLectureToChannel (lectureId, channelId, isShow, keyword, liveroomId) {
    return dispatch => {
        dispatch(setIsPending(true))
        axios.post(`/api/lecture/${lectureId}/edit`, qs.stringify({
            channel: +channelId,
            show_in_liveroom_list: isShow,
        }))
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setIsAlert(true))
                    dispatch(setAlertMsg(res.data.msg))
                    return
                }
                dispatch(fetchLectures(liveroomId, { keyword: keyword }))
                dispatch(setIsSuccess(true))
                setTimeout(() => { dispatch(setIsSuccess(false)) }, 2000)
            })
    }
}

export function delLecture (lectureId, liveroomId, keyword) {
    return dispatch => {
        dispatch(setIsPending(true))
        return axios.post(`/api/lecture/${lectureId}/delete`)
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setNoDelReason(res.data.msg))
                    dispatch(setIsNoDel(true))
                    return
                }
                dispatch(setIsSuccess(true))
                dispatch(fetchLectures(liveroomId, { keyword }))
                setTimeout(() => { dispatch(setIsSuccess(false)) }, 2000)
            })
    }
}

export function postCheckDelLecture(lectureId) {
    return dispatch => {
        dispatch(setIsPending(true))
        return axios.post(`/api/lecture/${lectureId}/check_delete`)
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setNoDelReason(res.data.msg))
                    dispatch(setIsNoDel(true))
                    return
                }
                dispatch(setIsShowDelLecture(true))
            })
    }
}

export function postCheckDelChannel(channelId) {
    return dispatch => {
        dispatch(setIsPending(true))
        return axios.post(`/api/channel/${channelId}/check_delete`)
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setNoDelReason(res.data.msg))
                    dispatch(setIsNoDel(true))
                    return
                }
                dispatch(setIsShowDelChannel(true))
            })
    }
}

export function delChannel (channelId, liveroomId, keyword) {
    return dispatch => {
        dispatch(setIsPending(true))
        return axios.post(`/api/channel/${channelId}/delete`)
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setNoDelReason(res.data.msg))
                    dispatch(setIsNoDel(true))
                    return
                }
                dispatch(setIsSuccess(true))
                dispatch(fetchChannels(liveroomId, { keyword }))
                setTimeout(() => { dispatch(setIsSuccess(false)) }, 2000)
            })
    }
}

export function postMoveChannel(channelId, liveroomId, action, channelIndex) {
    return dispatch => {
        dispatch(setIsPending(true))
        dispatch(setIsChaMenuShow(false))
        return axios.post(`/api/channel/${channelId}/edit`, qs.stringify({
            move_priority: action,
        }))
            .then(res => {
                dispatch(setIsPending(false))
                if (res.data.code !== 0) {
                    dispatch(setIsAlert(true))
                    dispatch(setAlertMsg(res.data.msg))
                    return
                }
                dispatch(setIsSuccess(true))
                // dispatch(fetchChannels(liveroomId))
                dispatch(exchangeChannel(channelIndex, action === 'up' ? channelIndex - 1 : channelIndex + 1))
                setTimeout(() => { dispatch(setIsSuccess(false)) }, 1000)
                updateSuccess({ type: 'channel' })
            })
    }
}


// WEBPACK FOOTER //
// ./src/actions/liveroomSettingLecture.js